export default __webpack_public_path__ + "static/9662copy-b57112080111f1882b1249fdeb0f351a.jpg";